export class ComportamentoRegra {
    comportamentoRegraId: number;
    nome: string;

    constructor(dtoComportamentoRegra: any) {
        this.comportamentoRegraId = dtoComportamentoRegra.comportamentoRegraID;
        this.nome = dtoComportamentoRegra.nome;
    }
}
